import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Image } from '@application/Interfaces/Atoms/Image'
import { HeroLandingViewType } from '@application/Types/ComponentTypes'

import {
    Description,
    HeadingContainer,
    ImageWrapper,
    Search,
    SubDescription,
    Title,
    Widget,
    Wrapper,
} from './HeroLandingView.styled'

export const HeroLandingView = ({
    landingTitle,
    description,
    subDescription,
    image,
    imageAnimation,
    showQuoteForm,
    quoteFormDefaultMode,
    showHelpCenterSearchForm,
    localSearch,
    mode,
}: HeroLandingViewType): JSX.Element => {
    return (
        <Wrapper $mode={mode}>
            <HeadingContainer>
                <Title $mode={mode}>{landingTitle}</Title>
                {description?.data && (
                    <Description $mode={mode}>
                        <Html content={description.data.childMarkdownRemark.html} />
                    </Description>
                )}
                {subDescription?.data && (
                    <SubDescription $mode={mode}>
                        <Html content={subDescription.data.childMarkdownRemark.html} />
                    </SubDescription>
                )}
                <Widget showQuoteForm={showQuoteForm} quoteFormDefaultMode={quoteFormDefaultMode} />
                {showHelpCenterSearchForm && localSearch && <Search localSearch={localSearch} />}
            </HeadingContainer>
            {image && (
                <ImageWrapper>
                    <Image image={image} imageAnimation={imageAnimation} />
                </ImageWrapper>
            )}
        </Wrapper>
    )
}
